/**
 * Resolve a possibly-relative external URL to an absolute one.
 *
 * The backend stores Facebook permalinks as relative inbox paths
 * (e.g. `/103963892532587/inbox/644537825141855/?section=messages`).
 * We prefix with https://www.facebook.com when the value is relative;
 * absolute http(s) URLs are passed through unchanged so this helper
 * stays forward-compatible with other platforms.
 */
export const resolveExternalUrl = (url: string | null | undefined) => {
  if (!url) return null
  if (/^https?:\/\//i.test(url)) return url
  return `https://www.facebook.com${url.startsWith('/') ? '' : '/'}${url}`
}
